// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Move_wrapper__3vCxE","move":"Move_move__l1bRx"};